import BaseStore from 'fluxible/addons/BaseStore';

class UserStore extends BaseStore {

  constructor(dispatcher) {
    super(dispatcher);
    this.user = null;
    this.userResources = {};
    this.profile = {};
    this.framedAccount = undefined;
  }

  isAuthenticated() {
    return this.user && this.user.isAuthenticated;
  }

  getUser() {

    return this.user;
  }

  getUserProfile() {
    return this.profile;
  }

  getSelectedClientId() {
    return this.userResources.selectedClientId;
  }

  getSelectedApiId() {
    return this.userResources.selectedApiId;
  }

  getSelectedApi() {
    const { nonGlobalApis = [] } = this.userResources;
    const selectedApiId = this.getSelectedApiId();

    const selectedApi = nonGlobalApis.find(api => api.identifier === selectedApiId);

    return {
      name: selectedApi ? selectedApi.name : selectedApiId,
      identifier: selectedApi ? selectedApi.identifier : selectedApiId
    };
  }

  getUserAccount() {
    if (this.framedAccount) {
      return this.framedAccount;
    }

    return this.user ? this.user.account : null;
  }

  handleUserLoaded({ user, profile = this.profile, userResources = this.userResources }) {
    this.user = user;
    this.profile = profile;
    this.userResources = userResources;
    this.emitChange();
  }

  handleFrameDataLoad({ account }) {
    this.framedAccount = account;
    this.emitChange();
  }

  dehydrate() {
    return {
      user: this.user,
      profile: this.profile,
      userResources: this.userResources,
      framedAccount: this.framedAccount
    };
  }

  rehydrate({ user, profile, userResources, framedAccount }) {
    this.user = user;
    this.profile = profile;
    this.userResources = userResources;
    this.framedAccount = framedAccount;
  }
}

UserStore.storeName = 'UserStore';
UserStore.handlers = {
  USER_LOADED: 'handleUserLoaded',
  FRAME_DATA_LOADED: 'handleFrameDataLoad'
};

export default UserStore;
